import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useState } from 'react';

import { Accordion, Card, Table } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';
import { applicationApi } from '../../api';
import { MyInnaEducation } from '../../api/openapi';

const ApplicationINNAEducation: React.FC = () => {
  const { t } = useTranslation(['viewApplicationInna', 'common']);
  const [data, setData] = useState<MyInnaEducation[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const getInnaEducation = useCallback(() => {
    setLoading(true);

    applicationApi
      .myInnaEducation()
      .then((response) => {
        setData(response.data);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    getInnaEducation();
  }, [getInnaEducation]);

  if (error) {
    return <>{t('common:kerfisvilla')}</>;
  }

  if (loading || data == null) {
    return (
      <>
        <FontAwesomeIcon spin icon={faSpinner} />
      </>
    );
  }

  return (
    <>
      <Accordion>
        <Card className="mb-2">
          <Accordion.Toggle as={Card.Header} eventKey="1" className="h4 border-bottom-0" style={{ backgroundColor: 'white' }}>
            {t('educationInformation')}
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              {data.length === 0 ? (
                <>{t('noINNADataFound')}</>
              ) : (
                <Table striped bordered hover className="mt-5">
                  <thead>
                    <tr>
                      <th>{t('school')}</th>
                      <th>{t('semester')}</th>
                      <th>{t('course')}</th>
                      <th>{t('courseName')}</th>
                      <th>{t('dateFinished')}</th>
                      <th>{t('status')}</th>
                      <th>{t('grade')}</th>
                      <th>{t('credit')}</th>
                      <th>{t('level')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((d) => (
                      <tr>
                        <td>{d.skoliAudk}</td>
                        <td>{d.onnEink}</td>
                        <td>{d.namsgreinAfanganr}</td>
                        <td>{d.namsgreinHeiti}</td>
                        <td>{d.dagsLokid}</td>
                        <td>{d.stadaAfanga}</td>
                        <td>{d.einkunn}</td>
                        <td>{Math.round(Number(d.einingarFerill))}</td>
                        <td>{d.trep}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </>
  );
};
export default ApplicationINNAEducation;
